module.exports.fontFamily = {
  sans: [
    'var(--font-lato, Lato)',
    'Helvetica Neue',
    'Helvetica',
    'Roboto',
    'AvenirNext-Regular',
    'Avenir Next',
    'Avenir',
    'sans-serif',
  ],
  times: ['Times', 'serif'],
  arial: ['Arial', 'sans-serif'],
};
